
import { defineComponent } from "vue";
import * as apiClient from "@/apiclient/";
import { mapGetters, mapMutations } from "vuex";
import { RequiredDocumentDto } from "@/apiclient/types/RequiredDocumentDto";
import common from "@/config/common";
import RequiredDocument from "./RequiredDocument.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import eventBus from "@/utils/eventBus";
import helper from "@/utils/helper";
import routesPath from "@/config/routesPath";
import DocumentUploadDragAndDrop from "./DocumentUploadDragAndDrop.vue";

export default defineComponent({
  name: "GroupInsuranceDocuments",
  components: {
    RequiredDocument,
    AppFooter,
    DocumentUploadDragAndDrop,
  },
  data() {
    return {
      enrollment: null as object | null,
      documents: undefined as RequiredDocumentDto[] | null | undefined,
      isDragging: false,
      files: [],
      validationMsg: "" as string,
    };
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      eventBus.on("refresh-document-data", () => {
        this.loadData();
      });

      var customerParticipantId = this.getEnrollment.customerParticipantId;

      if (customerParticipantId != null) {
        var result = await apiClient
          .documentController()
          .getApiDocumentGetRequiredDocuments({
            customerParticipantId: customerParticipantId,
          });

        this.documents = result.data?.documents;
      }

      if (!this.documents || !this.documents.length) {
        this.setDocumentSubmitBtn("SKIP & NEXT");
      } else {
        this.setDocumentSubmitBtn("NEXT");
      }
    },
    ...mapMutations(["setDocumentSubmitBtn"]),
    submitHandler() {
      helper.setPageStep(common.pageStep.documents);
      this.$router.push({ name: routesPath.confirmation });
    },
    setValidationMessage(message: string) {
      this.validationMsg = message;
    },
  },
  computed: {
    ...mapGetters(["getEnrollment", "getDocumentSubmitBtn"]),
    isSubmitDisabled() {
      var unfinishedDocuments = this.documents?.filter(
        (document) => document.currentDocument == null
      );

      if (unfinishedDocuments) {
        return unfinishedDocuments.length > 0;
      }

      return false;
    },
  },
});
